import { render, staticRenderFns } from "./FansAdd.vue?vue&type=template&id=85a2a444&scoped=true&"
import script from "./FansAdd.vue?vue&type=script&lang=js&"
export * from "./FansAdd.vue?vue&type=script&lang=js&"
import style0 from "./FansAdd.vue?vue&type=style&index=0&id=85a2a444&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85a2a444",
  null
  
)

export default component.exports